<template>
  <div class="custom-pagination">
   <ul class="reset" v-if="pagenavs.length > 1">
      <li v-bind:key="'pna' + index" v-for="(nav, index) in pagenavs" :class="nav == '...' ? 'no-link' : ''">
        <a @click.prevent="callback(nav)" href="#" :class="nav == currentpage ? 'active-link' : ''">{{ nav }}</a>
      </li>
    </ul>
  </div>
</template>


<script>

export default {
  name: 'customPagination',
  props:{
    pagenavs: { type: Array },
    currentpage: { type: Number },
    callback: { type: Function },
  },
  data(){
    return {
    }
  },
};
</script>